import { AxiosRequestConfig } from 'axios';

import { BASE_API } from '../utils';

import { ModifiedSkillsByClass } from './types';

// Note: `active` is used for soft-deleting (archiving),
// while `available` refers to whether the Assignment is available to the Students
interface Update {
  active?: boolean; // For unarchiving
  available?: boolean;
  modifiedSkillsByClass?: ModifiedSkillsByClass; // For unarchiving
  releaseDate?: string | null;
}

interface UpdateConfig extends AxiosRequestConfig {
  body: Update;
  data: Update;
  method: 'PATCH';
  url: `/classes/${string}/assignments/${string}`;
}

/**
 * PATCH /vo/v1/classes/{class_id}/assignments/{aic_id}
 *
 * {
 *   active?: boolean
 *   available?: boolean
 *   releaseDate?: string
 *   modifiedSkillsByClass?: ModifiedSkillsByClass
 * }
 */
export const update = (
  classId: string,
  aicId: string,
  data: Update,
): UpdateConfig => {
  return {
    baseURL: BASE_API,
    method: 'PATCH',
    url: `/classes/${classId}/assignments/${aicId}`,
    body: data,
    data,
  } as const;
};
